/* O.C. WOMEN'S HAIR – Storefront-Event-Tracking (dataLayer).
   Reine dataLayer-Pushes; ob daraus ein Google-/Meta-Hit wird, entscheidet GTM
   anhand des Consent-Zustands (Consent Mode v2). Keine eigenen Cookies.
   Flags/Kontext werden in layout/theme.liquid gesetzt:
     window.__wTrackCta, window.__wTrackTypeform, window.__wTemplate
   Standort der Push-LP wird in sections/women-lp.liquid gesetzt: window.__wLpStandort
   Die Booking-Conversion (terminbuchung_abgeschlossen) feuert inline in
   sections/women-confirm.liquid – nicht hier. */
(function () {
  window.dataLayer = window.dataLayer || [];

  /* 1) "Beratung buchen"-Klicks (women-booking-cta, überall).
        Delegierter Listener in der Capture-Phase, damit auch Klicks auf
        innere Elemente (SVG-Icon) erfasst werden. */
  if (window.__wTrackCta) {
    document.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest ? e.target.closest('[data-women-cta]') : null;
        if (!a) return;
        window.dataLayer.push({
          event: 'booking_cta_click',
          standort: a.getAttribute('data-standort') || 'unbekannt',
          seitentyp: window.__wTemplate || ''
        });
      },
      true
    );
  }

  /* 2) Typeform-Lead (Push-LPs). Das Typeform-Embed postet beim Absenden eine
        Nachricht von *.typeform.com. Die Payload-Form variiert je Embed-Version
        → tolerant prüfen. In Phase 3 gegen die echte Payload verifizieren
        (Konsole: window.addEventListener('message', e=>console.log(e.origin,e.data))). */
  if (window.__wTrackTypeform) {
    var fired = false;
    window.addEventListener('message', function (e) {
      if (typeof e.origin === 'string' && e.origin.indexOf('typeform.com') === -1) return;
      var d = e.data || {};
      var type = typeof d === 'string' ? d : d.type || d.event || '';
      if (/submit/i.test(String(type)) && !fired) {
        fired = true;
        window.dataLayer.push({
          event: 'typeform_lead',
          standort: window.__wLpStandort || ''
        });
      }
    });
  }
})();
